// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { CredentialBilling } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Model/Billing';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

const useCredentialBillings: () => UseQueryResult<
  TemplateContract<CredentialBilling>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator, party } = useParties();
  return useQueryWithOffset({
    queryKey: ['queryCredentialBillings', operator, party],
    queryFn: async (_, offset: number) => {
      return ledgerApi.queryCredentialBillings(offset, operator);
    },
  });
};

export default useCredentialBillings;
